interface Data {
  handle: string;
  id: number;
}

export default class ShopifyApi {
  ENDPOINT = '/apps/green-comfort/wishlist';

  hasItem(data: Data) {
    return theme.customer?.wishlist.includes(data.id);
  }

  async addItem(data: Data) {
    const response = await fetch(`${this.ENDPOINT}/items`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'post',
      body: JSON.stringify(data.id),
    });

    const items = await response.json();
    theme.customer.wishlist = items;
  }

  async removeItem(data: Data) {
    const response = await fetch(`${this.ENDPOINT}/items`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'delete',
      body: JSON.stringify(data.id),
    });

    const items = await response.json();
    theme.customer.wishlist = items;
  }

  toggleItem(data: Data) {
    return this.hasItem(data) ? this.removeItem(data) : this.addItem(data);
  }

  async clearItems() {
    await fetch(`${this.ENDPOINT}`, {
      method: 'delete',
    });

    theme.customer.wishlist = [];
  }

  getItems() {
    return theme.customer?.wishlist ?? [];
  }
}
